<div  class="warning-message">
<!-- comment test-->
<alert aria-live="assertive"
  type="{{ type }} {{ type }}-box"
  [dismissible]="dismissible"
  [isOpen]="isOpen"
  (onClosed)="onClose()"
>
  @if (heading) {
    <header class="pb-2">
      <h1 class="alert-heading" [innerHTML]="heading"></h1>
    </header>
  }
  <section>
      <ng-content></ng-content>
  </section>
  @if (confirm) {
    <footer class="pt-2 text-end">
      <button
        class="col-12 col-md-3 col-lg-2 btn btn-inherit btn-sm"
        (click)="onClose()"
      >
        @if (icon) {
          <i class="fa fa-{{ icon }}"></i>
        }
        {{ confirm }}
      </button>
    </footer>
  }
</alert>
</div>
